import { render, staticRenderFns } from "./drg_dip_contract.vue?vue&type=template&id=0c75017a&scoped=true"
import script from "./drg_dip_contract.vue?vue&type=script&lang=js"
export * from "./drg_dip_contract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c75017a",
  null
  
)

export default component.exports